import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { LogIn, Chrome } from "lucide-react";

const inputCls =
  "w-full px-4 py-3 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#F5B301] placeholder:text-slate-400";

export function ClienteLogin({ titulo, subtitulo, redirectPath, onToken, prefix = "client" }) {
  const [telefone, setTelefone] = useState("");
  const [cpf, setCpf] = useState("");
  const [loading, setLoading] = useState(false);

  const entrarGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + redirectPath;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const entrar = async () => {
    setLoading(true);
    try {
      const r = await api.post("/cliente/acesso", { telefone, cpf });
      localStorage.setItem("client_token", r.data.token);
      onToken(r.data.token, r.data.nome, { nome: r.data.nome, telefone, cpf });
    } catch (e) {
      toast.error(e.response?.data?.detail || "Não foi possível acessar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-5 pt-8" data-testid={`${prefix}-login`}>
      <h1 className="font-heading text-2xl font-bold text-navy text-center">{titulo}</h1>
      <p className="text-sm text-slate-500 text-center mt-2 mb-5">{subtitulo}</p>
      <button data-testid={`${prefix}-google-login-btn`} onClick={entrarGoogle}
        className="w-full py-4 rounded-2xl bg-white border-2 border-slate-200 text-navy font-heading font-extrabold text-sm flex items-center justify-center gap-2 active:scale-95 transition-transform mb-4">
        <Chrome className="w-4 h-4" /> ENTRAR COM GOOGLE
      </button>
      <div className="flex items-center gap-3 mb-5">
        <div className="flex-1 h-px bg-slate-200" />
        <span className="text-[10px] font-bold text-slate-400 uppercase">ou com telefone e CPF</span>
        <div className="flex-1 h-px bg-slate-200" />
      </div>
      <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Telefone / WhatsApp</label>
      <input data-testid={`${prefix}-telefone-input`} inputMode="tel" className={`${inputCls} mt-1 mb-3`} placeholder="(21) 99999-9999" value={telefone} onChange={(e) => setTelefone(e.target.value)} />
      <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">CPF</label>
      <input data-testid={`${prefix}-cpf-input`} inputMode="numeric" className={`${inputCls} mt-1 mb-5`} placeholder="000.000.000-00" value={cpf} onChange={(e) => setCpf(e.target.value)} />
      <button data-testid={`${prefix}-login-btn`} onClick={entrar} disabled={loading}
        className="w-full py-4 rounded-2xl bg-navy text-[#F5B301] font-heading font-extrabold text-sm flex items-center justify-center gap-2 active:scale-95 transition-transform disabled:opacity-60">
        <LogIn className="w-4 h-4" /> {loading ? "Verificando..." : "ACESSAR"}
      </button>
      <Link to="/" className="block text-center text-xs text-slate-400 underline mt-4">Voltar ao início</Link>
    </div>
  );
}
